import { Component } from "@angular/core";

@Component({
    selector: "ifb-account-facility-card",
    templateUrl: "./account-facility-card.component.html",
    styleUrls: ["./account-facility-card.component.scss"],
    standalone: false
})
export class AccountFacilityCardComponent {}
